<template>
  <!-- standalone: just the button, used in InventorySyncPanel -->
  <div v-if="standalone" class="d-flex align-items-center gap-3">
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      :disabled="quickSyncing"
      @click="quickSync"
    >
      <loading-spinner v-if="quickSyncing" small="true" class="me-1" />
      <i v-else class="bi bi-arrow-clockwise me-1"></i>
      {{ quickSyncing ? 'Syncing...' : 'Sync Recent' }}
    </button>
    <span v-if="quickMessage" class="small text-success">{{ quickMessage }}</span>
  </div>

  <!-- default: compact toolbar used in the inventory list header -->
  <div v-else class="d-flex align-items-center gap-2 flex-wrap">
    <span class="fw-bold small">sync:</span>
    <router-link
        :to="{ name: 'Settings-DataItems', params: { storeKey: $route.params.storeKey } }"
        class="btn btn-sm btn-link px-0"
    >
      <i class="bi bi-arrow-repeat me-1"></i>Full
    </router-link>

    <div class="opacity-25">|</div>

    <div>
      <button
          type="button"
          class="btn btn-sm btn-link px-0"
          :disabled="quickSyncing"
          @click="quickSync"
      >
        <loading-spinner v-if="quickSyncing" small="true" class="me-1" />
        <i v-else class="bi bi-arrow-clockwise"></i>
        {{ quickSyncing ? 'Syncing...' : 'Recent' }}
      </button>
      <span v-if="quickMessage" class="ms-2 small text-success">{{ quickMessage }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import { useStore } from 'vuex'
import LoadingSpinner from '@/app/components/Utils/LoadingSpinner.vue'

defineProps({
  standalone: { type: Boolean, default: false }
})

const store = useStore()

const quickSyncing = ref(false)
const quickMessage = ref('')
let quickMessageTimer = null

async function quickSync() {
  quickSyncing.value = true
  quickMessage.value = ''
  try {
    const result = await store.dispatch('eshop/syncInventoryFromEbay')
    if (result.refreshedOnly) {
      quickMessage.value = 'Refreshed'
    } else if (result.newItems?.length > 0) {
      quickMessage.value = `${result.newItems.length} new item${result.newItems.length !== 1 ? 's' : ''} imported`
    } else {
      quickMessage.value = 'Up to date'
    }
    clearTimeout(quickMessageTimer)
    quickMessageTimer = setTimeout(() => { quickMessage.value = '' }, 4000)
  } catch (err) {
    quickMessage.value = err.response?.data?.error || err.message || 'Sync failed'
  } finally {
    quickSyncing.value = false
  }
}
</script>
